/**
 * Categoria de contato → nome + cor. Usado em Contatos, Conversas, Início
 * ("Contatos recentes") e na escolha "Quem é X pra você" do contato. A cor
 * aparece na etiqueta e, bem suave, no fundo das iniciais de quem não tem foto.
 */
export type CatInfo = { label: string; c: string };

export const CAT: Record<string, CatInfo> = {
  familia: { label: 'Família', c: '#8D5EB7' },
  amigos: { label: 'Amigos', c: '#E1A100' },
  namorado: { label: 'Amor', c: '#E15F8E' },
  trabalho: { label: 'Trabalho', c: '#3A5BC7' },
  clientes: { label: 'Clientes', c: '#7C3AED' },
  cliente: { label: 'Clientes', c: '#7C3AED' },
  leads: { label: 'Leads', c: '#0E9F6E' },
  parceiros: { label: 'Parceiros', c: '#2563EB' },
  fornecedores: { label: 'Fornecedores', c: '#64748B' },
  servicos: { label: 'Serviços', c: '#0891B2' },
  comunidade: { label: 'Comunidade', c: '#8B5CF6' },
  grupos: { label: 'Grupos', c: '#8B5CF6' },
  desconhecidos: { label: 'Novos', c: '#94A3B8' },
  conhecido: { label: 'Conhecidos', c: '#64748B' },
  outro: { label: 'Outros', c: '#64748B' },
};

export const FALLBACK_CAT: CatInfo = {
  label: 'Contato',
  c: '#93857A',
};

/**
 * Categorias criadas pelo dono (nome + cor), guardadas em preferences.customCategories.
 * As antigas ainda trazem `img` (o personagem que ilustrava a categoria); o
 * campo fica só para ler o que já está salvo e não é mais exibido nem gravado.
 */
export interface CustomCategory {
  id: string;
  label: string;
  c: string;
  img?: string;
}

export function readCustomCategories(
  preferences: Record<string, unknown> | undefined,
): CustomCategory[] {
  const raw = preferences?.customCategories;
  return Array.isArray(raw) ? (raw as CustomCategory[]) : [];
}

export function catInfo(value: string | null | undefined, custom?: CustomCategory[]): CatInfo {
  if (!value) return FALLBACK_CAT;
  const found = CAT[value];
  if (found) return found;
  const customMatch = custom?.find((c) => c.id === value);
  if (customMatch) return customMatch;
  return FALLBACK_CAT;
}

/** Cor para o fundo das iniciais: a da categoria, ou nada (neutro) sem categoria conhecida. */
export function catColor(
  value: string | null | undefined,
  custom?: CustomCategory[],
): string | null {
  const info = catInfo(value, custom);
  return info === FALLBACK_CAT ? null : info.c;
}
